const common ={
    KEY_SHOPPING: 'shoppingList',
}

export {common};